<template>
	<el-dialog title="查询产品信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="1200px"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">
				<div class="grid-height">

					<div class="table_main">
						<vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
						@cell-click="cellClickEvent"
							@radio-change="radioChangeEvent"
							show-overflow height="385" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">

							<template #form>
								<div class="clearfix screen-btns">
									<div class="fr">
										<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
											status="primary" plain>重置</vxe-button>
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="searchData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="网点名称:" field="name">
                    <template v-slot>
                      <el-input v-model="searchData.userName" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="联系人电话:" field="manPhonee">
                    <template v-slot>
                      <el-input v-model="searchData.userMobile" size="small" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="状态:" field="status">
                    <template v-slot>
                      <el-select v-model="searchData.stat" clearable>
                        <el-option :value="1" label="待审核"></el-option>
                        <el-option :value="2" label="审核中"></el-option>
                        <el-option :value="3" label="审核驳回"></el-option>
                        <el-option :value="5" label="已审核"></el-option>
                        <el-option :value="91" label="暂停"></el-option>
                        <el-option :value="92" label="暂挂"></el-option>
                        <el-option :value="98" label="撤消"></el-option>
                        <el-option :value="99" label="黑名单"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
								</vxe-form>
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid>
					</div>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
export default {
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param'],
	mixins: [selectDialogMixins],
	components: { pager },

  created() {
    this.initSetting();
  },

  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

	data() {
		return {
      total: 0,
			data: [],
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
      isRouterAlive: true,
			// 查询参数
			formData: {
				size: 0,
				current: 1,
				searchCount: false,
        userName: '',
        userMobile: '',
        stat: ''
			},
      searchData: {
        userName: '',
        userMobile: '',
        stat: ''
      },
			showDialog: true,
			falseValue: false,
			selectMulti: true,
      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',
      selectedRow: {
        id: '', name: ''
      }
		};
	},


	methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

		cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },


    radioChangeEvent ({ row }) {
      this.selectedRow = {id: row.id, name: row.userName}
    },


    commitRow() {
			this.$emit('commitSelectedRow', this.selectedRow)
      this.dialogClose()
		},


		// 分页功能
		changeTablePage(page, flag) {
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
      this.formData.userName = this.searchData.userName
      this.formData.stat = this.searchData.stat
      this.formData.userMobile = this.searchData.userMobile

			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},

		// 重置
		resetEvent() {
      this.searchData = {
        userName: '',
        userMobile: '',
        stat: ''
      }

      this.formData.userName = ''
      this.formData.userMobile = ''
      this.formData.stat = ''
			this.formData.current = 1
      this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},


		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},


		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: api.snUser.getPageDataUrl,
				param: this.formData,
				method: 'post',
        columns: [
          { type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
          { title: '网点名称', field: 'userName', width: 150, },
          { title: '网点简称', field: 'userShortName', width: 150 },
          // { title: '联系人姓名', field: 'man', width: 150 },
          { title: '联系人电话', field: 'userMobile', width: 150 },
          { title: '网点地址', field: 'address', width: 150, slots: {
              default: ({row}) => {
                return [
                  <div>
                    <span>{row.userProvince}{row.userCity}{row.userCounty}{row.userTown} {row.userAddress}</span>
                  </div>
                ]
              }
            }},
          // { title: '服务商编码', field: 'code', width: 150 },
          { field: 'stat', title: '状态', width: 150, slots: {
              default: ({row}) => {
                if (row.stat == 1) {
                  return [
                    <div >
                      <span>待审核</span>
                    </div>
                  ];
                } else if (row.stat == 2) {
                  return [
                    <div >
                      <span>审核中</span>
                    </div>
                  ];
                } else if (row.stat == 3) {
                  return [
                    <div >
                      <span>审核驳回</span>
                    </div>
                  ];
                } else if (row.stat == 5) {
                  return [
                    <div >
                      <span>已审核</span>
                    </div>
                  ];
                } else if (row.stat == 91) {
                  return [
                    <div>
                      <span>暂停</span>
                    </div>
                  ];
                } else if (row.stat == 92) {
                  return [
                    <div>
                      <span>暂挂</span>
                    </div>
                  ];
                } else if (row.stat == 98) {
                  return [
                    <div>
                      <span>撤消</span>
                    </div>
                  ];
                } else if (row.stat == 99) {
                  return [
                    <div>
                      <span>黑名单</span>
                    </div>
                  ];
                }
              }
            }
          },
          { field: 'createTime', title: '创建时间', width: 150 },
        ],
			};
			this.vxeOption = initVxeTable(tableOption);
      this.flushed()
		},


		// 加载页面
		loadChildNode(node, resolve) {
			fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({ data }) => {
				console.log(data, "data.data的值"),
					resolve(
						data.data.map(item => {
							return {
								label: item.categoryName,
								id: item.id,
								leaf: Number(item.isChild) == 1 ? false : true,
							}
						})
					)
			});
		},

	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height: 400px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	// width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}
  ::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
    font-size: 14px !important;
}
</style>
